import { PaymentIconName } from "src/components/unstyled/PaymentIcon"
import { WCStorePaymentMethod } from "src/data/woocommerce/wcStoreTypes"

// https://www.mollie.com/de/payments
// https://www.mollie.com/de/resources

export const paymentMethodIcon: Record<WCStorePaymentMethod, PaymentIconName> = {
  mollie_wc_gateway_applepay: "applepay",
  mollie_wc_gateway_banktransfer: "bank-transfer",
  mollie_wc_gateway_creditcard: "credit-card",
  mollie_wc_gateway_eps: "eps",
  mollie_wc_gateway_ideal: "ideal",
  mollie_wc_gateway_klarna: "klarna",
  mollie_wc_gateway_paypal: "paypal",
  mollie_wc_gateway_trustly: "trustly",
  paypal: "paypal",
}

export const paymentMethodLabel: Record<WCStorePaymentMethod, string> = {
  mollie_wc_gateway_applepay: "Apple Pay",
  mollie_wc_gateway_banktransfer: "Überweisung",
  mollie_wc_gateway_creditcard: "Kredit- und Debitkarte",
  mollie_wc_gateway_eps: "EPS",
  mollie_wc_gateway_ideal: "iDEAL",
  mollie_wc_gateway_klarna: "Klarna",
  mollie_wc_gateway_paypal: "PayPal",
  mollie_wc_gateway_trustly: "Trustly",
  paypal: "PayPal",
}
